import styled from "styled-components";

export const MissionListTabsStyled = styled.div`
  display: flex;
  gap: 4px;
`;
